import { render } from "./DialogReferralRewards.vue?vue&type=template&id=22773dca&scoped=true"
import script from "./DialogReferralRewards.vue?vue&type=script&lang=js"
export * from "./DialogReferralRewards.vue?vue&type=script&lang=js"

import "./DialogReferralRewards.vue?vue&type=style&index=0&id=22773dca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22773dca"]])

export default __exports__